<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)" class="text-start mb-5">
      <h4>
        Seu contrato de faturamento atual:
        {{ tipoFaturamentoLabelAtual }}
      </h4>
      <p>
        Os valores exibidos abaixo são estimativas do custo variável de acordo
        com a quantidade de serviço cloud utilizado. Caso seu plano de
        faturamento seja diferente, você pode utilizar as informações abaixo
        como comparativo à modalidade de cobrança ativa em seu plano.
      </p>
      <LineDivider />
      <v-row align="center">
        <v-col>
          <h4 class="ml-3">Início/Valor mensal de serviços</h4>
          <FormDatePicker v-model="selectedDate" month />
        </v-col>
        <v-col
          v-if="
            tipoFaturamento !== 'FIXO+PERCENTUAL' &&
              tipoFaturamento !== 'FAIXA_RECEITA' &&
              tipoFaturamento !== 'PERCENTUAL'
          "
        >
          <h4 class="ml-3">Tipo de custo</h4>
          <FormSelect
            v-model="buscaTipo"
            :options="tiposCusto"
            multiple
            clearable
          />
        </v-col>
        <v-col cols="auto">
          <FormButton text="Buscar" @click="filtrarCusto" />
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="text-center">
        <v-col>
          <v-card outlined height="100" class="d-flex align-center">
            <v-card-text class="py-5">
              <h3>
                VALOR TOTAL
                <span v-if="tipoFaturamento === 'FAIXA_RECEITA'">
                  COMPARATIVO
                </span>
              </h3>
              <span>
                Valor somado do período
                <span>{{
                  selectedDate
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
              </span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            outlined
            class="d-flex align-center"
            :height="exibirDecomposicaoModulos ? undefined : 100"
          >
            <v-card-text class="py-5">
              <h3>{{ dados.modules | formatMoney }}</h3>
              <span>Custo com Módulos</span>
              <template v-if="exibirDecomposicaoModulos">
                <br />
                <span>
                  Módulos fixos: {{ dados.modulesFixos | formatMoney }}
                </span>
                <br />
                <span>
                  Licenças contratadas:
                  {{ dados.modulesLicencas | formatMoney }}
                </span>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="auto" class="mx-n2" style="z-index: 2;">
          <v-icon size="18" color="success">fa-plus</v-icon>
        </v-col>
        <v-col>
          <v-card outlined height="100" class="d-flex align-center">
            <v-card-text class="py-5">
              <h3>{{ dados.cloud | formatMoney }}</h3>
              <span
                v-if="
                  tipoFaturamento === 'CUSTO_NUVEM' ||
                    tipoFaturamento === 'FAIXA_RECEITA'
                "
              >
                Custo com Nuvem
              </span>
              <span v-else>Custo variável</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="auto" class="mx-n2" style="z-index: 2;">
          <span
            style="font-size: 1.5em;"
            class="primario--text font-weight-bold"
          >
            =
          </span>
        </v-col>
        <v-col>
          <v-card outlined height="100" class="d-flex align-center">
            <v-card-text class="py-5">
              <h3>{{ dados.total | formatMoney }}</h3>
              <span>Valor Final</span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        v-if="tipoFaturamento === 'FAIXA_RECEITA'"
        class="text-center"
        align="center"
      >
        <v-col>
          <v-card outlined height="100" class="d-flex align-center">
            <v-card-text class="py-5">
              <h3>
                VALOR TOTAL FAIXA DE FATURAMENTO
              </h3>
              <span>
                Valor somado do período
                <span>{{
                  selectedDate
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
              </span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card outlined height="100" class="d-flex align-center">
            <v-card-text class="py-5">
              <h3>{{ dadosFaixa.faixaReceita | formatMoney }}</h3>
              <span>Faixa de Receita</span><br />
              <span>{{ dadosFaixa.faixaReceitaNomeFaixa }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="auto" class="mx-n2" style="z-index: 2;">
          <span
            style="font-size: 1.5em;"
            class="primario--text font-weight-bold"
          >
            =
          </span>
        </v-col>
        <v-col>
          <v-card outlined height="100" class="d-flex align-center">
            <v-card-text class="py-5">
              <h3>{{ dadosFaixa.total | formatMoney }}</h3>
              <span>Valor Final</span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </Panel>
    <Panel lineColor="var(--primary-color)" class="text-start mb-5">
      <v-row no-gutters>
        <h4>Detalhamento dos Módulos</h4>
        <v-icon
          class="ml-auto"
          v-if="showPanelModules"
          @click="changePanelModules"
        >
          fa-chevron-up
        </v-icon>
        <v-icon class="ml-auto" v-else @click="changePanelModules">
          fa-chevron-down
        </v-icon>
      </v-row>
      <LineDivider v-if="showPanelModules" />
      <!-- D20: linha expansível é default razoável; validar com produto/design antes de produção. -->
      <DataTable
        v-if="showPanelModules"
        :headers="headersModules"
        :endpoint="endpointModules"
        sortBy="module_name"
        show-expand
        :row-expandable="isModuleLicensable"
      >
        <template v-slot:module_name="{ col }">
          <v-row no-gutters>
            <v-col cols="2" class="text-center">
              <v-icon
                v-if="
                  col == 'Orçamento app' ||
                    col == 'Commerce app' ||
                    col == 'Venda+ app'
                "
                class="primario--text"
              >
                fa-mobile
              </v-icon>
              <v-icon
                v-else-if="
                  col == 'Web-commerce' ||
                    col == 'Orçamento web' ||
                    col == 'Venda+ web'
                "
                class="error--text"
              >
                fa-desktop
              </v-icon>
              <v-icon
                v-else-if="col == 'Painel de cliente'"
                class="warning--text"
              >
                fa-user
              </v-icon>
              <v-icon v-else class="success--text">
                fa-globe
              </v-icon>
            </v-col>
            <v-col class="ml-3">{{ col }}</v-col>
          </v-row>
        </template>
        <template v-slot:activation_date="{ col }">
          {{ col | formatDate }}
        </template>
        <template v-slot:module_total_price="{ row }">
          {{ precoExibidoModulo(row) | formatMoney }}
        </template>
        <template v-slot:expanded-item="{ item }">
          <div
            v-if="isModuleLicensable(item)"
            class="modulo-licenca-composicao"
          >
            <p class="caption mb-1 grey--text text--darken-1">
              Composição da licença
            </p>
            <p class="mb-1">
              Licenças contratadas:
              <strong>{{ item.contracted_license_quantity }}</strong>
            </p>
            <p class="mb-0">
              Valor unitário:
              <strong>{{ item.license_unit_price | formatMoney }}</strong>
            </p>
          </div>
        </template>
      </DataTable>
    </Panel>
    <ValorServicoLicencas :licencas="licencas" :competencia="selectedDate" />
    <Panel
      v-if="
        tipoFaturamento !== 'FIXO+PERCENTUAL' &&
          tipoFaturamento !== 'FAIXA_RECEITA' &&
          tipoFaturamento !== 'PERCENTUAL' &&
          tipoFaturamento !== 'FIXO+TAXA_POR_PEDIDO'
      "
      lineColor="var(--primary-color)"
      class="text-start mb-5"
    >
      <v-row no-gutters>
        <h4>Orçamento</h4>
        <v-icon
          class="ml-auto"
          v-if="showPanelBudget"
          @click="changePanelBudget"
        >
          fa-chevron-up
        </v-icon>
        <v-icon class="ml-auto" v-else @click="changePanelBudget">
          fa-chevron-down
        </v-icon>
      </v-row>
      <LineDivider v-if="showPanelBudget" />
      <v-row no-gutters v-if="showPanelBudget">
        <v-col cols="12" md="6" v-for="(o, i) in orcamentos" :key="i">
          <ValorServicoBudget
            :budget="o"
            :date="orcamentoDate"
            @modify-budget="atualizaOrcamento"
          />
        </v-col>
      </v-row>
    </Panel>
    <Panel
      v-if="tipoFaturamento === 'CUSTO_NUVEM'"
      lineColor="var(--primary-color)"
      class="text-start mb-5"
    >
      <h4>Detalhes do custo de cada item</h4>
      <LineDivider />
      <DataTable
        :headers="headersItens"
        :endpoint="endpointItens"
        sortBy="data_consolidacao"
        :limitPage="[10, 25, 50, 100, 200, 1000]"
        pdf
        csv
        excel
      >
        <template v-slot:valor_unitario="{ row }">
          {{
            new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
              minimumFractionDigits: 15,
              maximumFractionDigits: 15
            }).format(row.valor_unitario * row.quantidade)
          }}
        </template>
      </DataTable>
    </Panel>
    <Panel
      v-if="tipoFaturamento !== 'CUSTO_NUVEM' && mostrarTabelaPedidos"
      lineColor="var(--primary-color)"
      class="text-start"
    >
      <h4>Detalhes dos pedidos do custo</h4>
      <LineDivider />
      <DataTable
        v-if="idsPedidosConsiderados && idsPedidosConsiderados.length > 0"
        :headers="headersPedidos"
        :endpoint="endpointPedidos"
        sortBy="numpedido"
        :limitPage="[10, 25, 50, 100, 200, 1000]"
        pdf
        csv
        excel
      >
        <template v-slot:totalpedido="{ col }">
          {{ col | formatMoney }}
        </template>
        <template v-slot:datapedido="{ col }">
          {{ col | formatDateTime }}
        </template>
        <template v-slot:datahistorico="{ col }">
          <span v-if="col">{{ col | formatDateTime }}</span>
        </template>
        <template v-slot:valor_repasse="{ col }">
          {{
            new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
              minimumFractionDigits: 6,
              maximumFractionDigits: 6
            }).format(col)
          }}
        </template>
      </DataTable>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import MarketingModules from "@/components/MarketingModules";
import { mapGetters } from "vuex";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import {
  FATURA_LOAD,
  FATURA_LOAD_ORDER,
  FATURA_ACCEPT_ORDER
} from "@/store/actions/fatura";
import FormDatePicker from "@/components/form/FormDatePicker";
import FormSelect from "@/components/form/FormSelect";
import FormButton from "@/components/form/FormButton";
import LineDivider from "@/components/LineDivider";
import DataTable from "@/components/DataTable";
import ValorServicoBudget from "./components/ValorServicoBudget";
import ValorServicoLicencas from "./components/ValorServicoLicencas";
import {
  isModuleLicensable,
  normalizeLicencasFromApi,
  precoExibidoModulo
} from "./licencas-helpers";
import {
  deveExibirDecomposicaoModulos,
  resolveValorModulosFixos,
  resolveValorModulosLicencas,
  resolveValorModulosTotal
} from "./modulos-custo-helpers";

export default {
  name: "ValorServico",
  components: {
    Panel,
    MarketingModules,
    FormDatePicker,
    FormSelect,
    FormButton,
    LineDivider,
    DataTable,
    ValorServicoBudget,
    ValorServicoLicencas
  },
  data: () => ({
    modulosForm: [ModulesEnum.TODOS],
    buscaTipo: null,
    selectedDate: null,
    dados: {
      tipoFaturamento: "",
      cloud: "",
      modules: "",
      modulesFixos: "",
      modulesLicencas: "",
      total: ""
    },
    dadosFaixa: {
      tipoFaturamento: "",
      total: "",
      faixaReceita: "",
      faixaReceitaNomeFaixa: ""
    },
    billingType: {
      ACCESS_LISTA_PRODUTOS: "Acessos ao Aplicativo",
      STORAGE_CAROUSEL: "Armazenamento - Carrossel",
      ACCESS_VENDA_MAIS: "Uso do Venda+",
      STORAGE_ORDER: "Armazenamento - Pedido",
      STORAGE_PAYMENT_METHOD: "Armazenamento - Forma de pagamento",
      STORAGE_COUPON: "Armazenamento - Cupom de Desconto",
      STORAGE_USER: "Armazenamento - Usuário da Plataforma",
      STORAGE_CLIENT: "Armazenamento - Cliente",
      STORAGE_PRODUCT_MIX: "Armazenamento - Mix de Produtos",
      STORAGE_PRICE_GROUP: "Armazenamento - Tabela de Preços",
      SEND_MAIL_SMTP: "Envio de e-mails via SMTP",
      ACCESS_REPRESENTANTE: "Uso do Representante"
    },
    tipoFaturamentoLabel: {
      CUSTO_NUVEM: "Custo Nuvem",
      "FIXO+PERCENTUAL": "Valor Fixo + % Sob Vendas",
      PERCENTUAL: "% Sob Vendas",
      "FIXO+TAXA_POR_PEDIDO": "Valor Fixo + Taxa por pedido",
      FAIXA_RECEITA: "Faixa de Faturamento"
    },
    showPanelModules: false,
    showPanelBudget: true,
    orcamentos: [],
    orcamentoDate: "",
    idsPedidosConsiderados: [],
    tipoFaturamento: null,
    mostrarTabelaPedidos: false,
    licencas: [],
    headersModules: [
      {
        text: "Módulo",
        value: "module_name"
      },
      {
        text: "Fornecedor",
        value: "supplier_name"
      },
      {
        text: "Data Ativação",
        value: "activation_date"
      },
      {
        text: "Valor",
        value: "module_total_price",
        align: "center"
      }
    ],
    headersItens: [
      {
        text: "Data",
        value: "data_consolidacao"
      },
      {
        text: "Nome",
        value: "nome"
      },
      {
        text: "Quantidade",
        value: "quantidade",
        align: "center"
      },
      {
        text: "Valor",
        value: "valor_unitario",
        align: "center"
      }
    ],
    headersPedidos: [
      {
        text: "Pedido",
        value: "numpedido"
      },
      {
        text: "Valor do pedido",
        value: "totalpedido"
      },
      {
        text: "Data do pedido",
        value: "datapedido"
      },
      {
        text: "Data da última modificação",
        value: "datahistorico"
      },
      {
        text: "Total do repasse",
        value: "valor_repasse"
      }
    ]
  }),
  computed: {
    ...mapGetters(["getFornecedorId", "getEmpresaId", "moduloFornecedorAtivo"]),
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    },
    tiposCusto() {
      return Object.keys(this.billingType).map(key => ({
        value: key,
        text: this.billingType[key]
      }));
    },
    tipoFaturamentoLabelAtual() {
      return this.tipoFaturamentoLabel[this.tipoFaturamento];
    },
    endpointModules() {
      return `/api/v4/billing/modules/${this.getEmpresaId}`;
    },
    endpointItens() {
      return `/api/v4/billing/${this.getEmpresaId}?month=${
        this.selectedDate
      }-01&types=${(this.buscaTipo || []).map(item => item).join(",")}`;
    },
    endpointPedidos() {
      return `/api/v4/billing/${this.getFornecedorId}/orders?idspedidos=${this
        .idsPedidosConsiderados || []}`;
    },
    exibirDecomposicaoModulos() {
      return deveExibirDecomposicaoModulos(this.dados.modulesLicencas);
    }
  },
  methods: {
    isModuleLicensable,
    precoExibidoModulo,
    changePanelModules() {
      this.showPanelModules = !this.showPanelModules;
    },
    changePanelBudget() {
      this.showPanelBudget = !this.showPanelBudget;
    },
    filtrarCusto() {
      if (this.selectedDate) {
        this.mostrarTabelaPedidos = false;
        let filtroTipo = (this.buscaTipo || []).map(item => item).join(",");
        let newDate = this.selectedDate + "-01";
        this.getBilling(newDate, filtroTipo);
        this.getOrcamento(newDate);
      } else {
        this.$vueOnToast.pop("error", "Selecione a Data ");
      }
    },
    getBilling(newDate, types) {
      this.$store
        .dispatch(FATURA_LOAD, { newDate, types })
        .then(data => {
          const totalBillingAmount = Number.parseFloat(
            this.calcularValorFaturamento(data) || 0
          );
          const billing =
            data.tipofaturamento === "CUSTO_NUVEM"
              ? Number.parseFloat(data.custo_nuvem_periodo || 0)
              : Number(totalBillingAmount);
          const valor_modulos = resolveValorModulosTotal(data);
          const valor_modulos_fixos = resolveValorModulosFixos(data);
          const valor_modulos_licencas = resolveValorModulosLicencas(data);
          this.idsPedidosConsiderados = data.pedidos_considerados;
          this.tipoFaturamento = data.tipofaturamento;
          this.licencas = normalizeLicencasFromApi(data.licencas);

          if (
            this.tipoFaturamento !== "CUSTO_NUVEM" &&
            this.tipoFaturamento !== "FAIXA_RECEITA"
          ) {
            this.mostrarTabelaPedidos = true;
          }

          if (this.tipoFaturamento === "FAIXA_RECEITA") {
            this.setBilling(
              Number.parseFloat(data.custo_nuvem_periodo || 0),
              valor_modulos,
              valor_modulos_fixos,
              valor_modulos_licencas
            );
            this.setFaixaBilling(
              billing,
              data.tipofaturamento,
              data.faixa_receita.nome
            );
          } else {
            this.setBilling(
              billing,
              valor_modulos,
              valor_modulos_fixos,
              valor_modulos_licencas
            );
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.setBilling(0, 0);
          this.licencas = [];
          this.isLoading = false;
        });
    },
    setBilling(billing, modules, modulesFixos = modules, modulesLicencas = 0) {
      let total = modules + billing;
      this.dados.modules = modules.toFixed(2);
      this.dados.modulesFixos = modulesFixos.toFixed(2);
      this.dados.modulesLicencas = modulesLicencas.toFixed(2);
      this.dados.cloud = billing.toFixed(2);
      this.dados.faixaReceita = billing.toFixed(2);
      this.dados.total = total.toFixed(2);
    },
    setFaixaBilling(billing, tipoFaturamento, faixaNome) {
      let total = billing;
      this.dadosFaixa.tipoFaturamento = tipoFaturamento;
      this.dadosFaixa.faixaReceitaNomeFaixa = faixaNome;
      this.dadosFaixa.faixaReceita = total.toFixed(2);
      this.dadosFaixa.total = total.toFixed(2);
    },
    getOrcamento(newDate) {
      this.isLoading = true;
      this.$store
        .dispatch(FATURA_LOAD_ORDER, newDate)
        .then(data => {
          this.orcamentos = data.filter(
            item => this.billingType[item.nome_metrica]
          );
          this.orcamentoDate = newDate;
          this.isLoading = false;
        })
        .catch(err => {
          this.$vueOnToast.pop("error", err);
          this.isLoading = false;
        });
    },
    atualizaOrcamento(idtipometrica, previsao) {
      this.isLoading = true;
      this.$store
        .dispatch(FATURA_ACCEPT_ORDER, { idtipometrica, valor: previsao })
        .then(() => {
          this.filtrarCusto();
          this.$vueOnToast.pop("success", "Orçamento atualizado");
          this.isLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao atualizar orçamento");
          this.isLoading = false;
        });
    },
    calcularValorFaturamento(dados_empresa) {
      const n = val => (isNaN(Number(val)) ? 0 : Number(val));
      let result = 0;
      switch (dados_empresa.tipofaturamento) {
        case "CUSTO_NUVEM":
          result = n(dados_empresa.custo_nuvem_periodo);
          break;
        case "FIXO+PERCENTUAL":
          result =
            n(dados_empresa.total_vendas) *
            (n(dados_empresa.percrepasse) / 100);
          break;
        case "FIXO+PERCENTUAL_IMEDIATO":
          result =
            n(dados_empresa.total_vendas) *
            (n(dados_empresa.percrepasse) / 100);
          break;
        case "PERCENTUAL":
          result =
            n(dados_empresa.total_vendas) *
            (n(dados_empresa.percrepasse) / 100);
          break;
        case "FIXO+TAXA_POR_PEDIDO":
          result =
            (dados_empresa.pedidos_considerados || []).length *
            n(dados_empresa.percrepasse);
          break;
        case "FAIXA_RECEITA":
          result = dados_empresa.faixa_receita.valor;
          break;
      }
      return result;
    }
  },
  created() {
    this.selectedDate = new Date().toISOString().slice(0, 7);
    this.filtrarCusto();
  }
};
</script>
